import { Link } from 'react-router-dom'
import { captureEvent } from '@/lib/posthog'

interface DemoCtaLinkProps {
  /** Where on the page this CTA sits, e.g. 'nav' | 'hero' | 'final_cta' | 'mobile_nav'. */
  location: string
  className?: string
  children: React.ReactNode
  /** Optional extra click handler to compose (e.g. closing the mobile menu). */
  onClick?: () => void
}

export function DemoCtaLink({ location, className, children, onClick }: DemoCtaLinkProps) {
  const handleClick = () => {
    captureEvent('cta_clicked', { location, target: '/book-a-demo' })
    onClick?.()
  }
  return (
    <Link to="/book-a-demo" className={className} onClick={handleClick}>
      {children}
    </Link>
  )
}
